// =============================================================================
// 기본 템플릿 판별 — admin(타일 배지·삭제 금지)과 main(신규 조직 시드)이 같은 규칙을 쓴다.
// 1순위: Owner가 관리하는 명시 플래그(isTemplate). 2순위(플래그 없는 구 데이터): id가
// preset/template-brick-brief-* 이거나 이름이 「BRICK BRIEF (Chat 기본 템플릿)」/「[Template]…」.
// =============================================================================

export function isLegacyTemplateNotice(notice: { id: string; name: string }): boolean {
  return (
    /^preset-brick-brief$/i.test(notice.id) ||
    /^template-brick-brief-tpl-[123]$/i.test(notice.id) ||
    /^brick brief\s*\(chat 기본 템플릿\)$/i.test(notice.name) ||
    /^\[template\]/i.test(notice.name.trim())
  );
}

export function isTemplateNotice(notice: { id: string; name: string; isTemplate?: boolean }): boolean {
  if (typeof notice.isTemplate === 'boolean') return notice.isTemplate;
  return isLegacyTemplateNotice(notice);
}
